import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { WorkspaceDetailsBanner } from '../WorkspaceDetailsBanner'
import { DataBricksActionsSection } from './DataBricksActionsSection'
import { DatabricksStatusSection } from './DatabricksStatusSection'
import { DatabricksJobsSection } from './DatabricksJobsSection'
import { DatabricksRunsSection } from './DatabricksRunsSection'

export function WorkspaceDatabricksPageContentV2() {
  return (
    <SectionLayout>
      <WorkspaceDetailsBanner />
      <DatabricksStatusSection />
      <DataBricksActionsSection />
      <DatabricksJobsSection />
      <DatabricksRunsSection />
    </SectionLayout>
  )
}
